function getEnvVariable(key, defaultValue, metaEnvValue) {
  if (typeof window.runtimeConfig !== 'undefined' && window.runtimeConfig !== null && key in window.runtimeConfig) {
    return window.runtimeConfig[key];
  }
  if (typeof metaEnvValue !== 'undefined') {
    return metaEnvValue;
  }
  if (typeof defaultValue !== 'undefined') {
    return defaultValue;
  }
  return null;
}

const config = {
  cookies: {
    expirationTime: 365, // Days
    supportedCookies: ['necessary', 'thirdParty'],
  },
  debug: getEnvVariable('REACT_APP_DEBUG', !import.meta.env.PROD, import.meta.env.REACT_APP_DEBUG),
  api: {
    facebook: {
      clientid: getEnvVariable('REACT_APP_FACEBOOK_API_CLIENT_ID', '', import.meta.env.REACT_APP_FACEBOOK_API_CLIENT_ID),
    },
    google: {
      clientid: getEnvVariable('REACT_APP_GOOGLE_API_CLIENT_ID', '', import.meta.env.REACT_APP_GOOGLE_API_CLIENT_ID),
    },
    backend: {
      url: getEnvVariable('REACT_APP_API_URL', 'https://localhost:8000', import.meta.env.REACT_APP_API_URL),
      checkSessionInterval: import.meta.env.PROD ? 1000 * 60 * 5 : 1000 * 20,
    },
    openFoodFacts: {
      url: getEnvVariable('REACT_APP_OPENFOODFACTS_API_URL', 'https://world.openfoodfacts.org', import.meta.env.REACT_APP_OPENFOODFACTS_API_URL),
    },
  },
  locales: ['en', 'it'],
  socialLogin: {
    // Enable/Disable social login buttons
    google: true,
    facebook: true,
  },
  tracking: {
    openTelemetry: {
      tracker: getEnvVariable('REACT_APP_OPENTELEMETRY_TRACKER', 'false', import.meta.env.REACT_APP_OPENTELEMETRY_TRACKER),
      url: getEnvVariable('REACT_APP_OPENTELEMETRY_URL', 'http://localhost:4318/v1/traces', import.meta.env.REACT_APP_OPENTELEMETRY_URL),
      serviceName: getEnvVariable('REACT_APP_OPENTELEMETRY_SERVICE_NAME', 'FoodAdvisor', import.meta.env.REACT_APP_OPENTELEMETRY_SERVICE_NAME),
      applicationName: getEnvVariable('REACT_APP_OPENTELEMETRY_APPLICATION_NAME', 'FoodAdvisor', import.meta.env.REACT_APP_OPENTELEMETRY_APPLICATION_NAME),
      propagateTraceHeaderCorsUrls: getEnvVariable('REACT_APP_OPENTELEMETRY_PROPAGATE_TRACE_HEADER_CORS_URLS', '/.+localhost:4318.+/g', import.meta.env.REACT_APP_OPENTELEMETRY_PROPAGATE_TRACE_HEADER_CORS_URLS),
      sessionIdentifierField: getEnvVariable('REACT_APP_OPENTELEMETRY_SESSIONIDENTIFIERFIELD', 'randomTabIdentifier', import.meta.env.REACT_APP_OPENTELEMETRY_SESSIONIDENTIFIERFIELD),
    },
  },
};

export default config;
